var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 560 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00ffe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#00ffe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0862fb"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientTransform: "matrix(-53.198 -65.7151 65.7151 -53.198 57.9531 54.2132)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientTransform: "matrix(55.5449 -43.5493 43.5493 55.5449 6.1225 70.9154)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -4.7891,
    x2: 38.3722,
    xlinkHref: "#a",
    y1: 54.8008,
    y2: 54.8008
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientTransform: "matrix(0 51.7401 -51.7401 0 11.365 -.000017)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientTransform: "matrix(0 16.241 -16.241 0 29.9644 23.9735)",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 1,
    xlinkHref: "#a",
    y1: 0,
    y2: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.38143 0 0 1.38143 77.4689 155)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1b1c2b",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m120.91 44.53c-.8 8.66-8.36 14.66-17.1 14.66h-21.45l4.67-50.55h19.93c8.52 0 14.85 5.78 14.07 14.23-.4 4.33-2.52 7.73-5.7 10.11 3.83 2.31 6.07 6.28 5.58 11.55zm-24.77-26.57-1.03 11.12h9.97c3.11 0 5.64-2.38 5.93-5.56s-1.73-5.56-4.9-5.56zm14.94 25.92c.31-3.39-1.91-5.92-5.3-5.92h-11.49l-1.1 11.91h11.48c3.4.01 6.09-2.52 6.41-5.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m161.84 18.17h-13.65l-3.79 41.02h-9.97l3.8-41.02h-13.58l.88-9.53h37.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.74 33.92c1.37-14.8 13.41-26.29 28.72-26.29 9.25 0 16.97 4.7 20.63 11.91l-9.06 4.98c-2.04-4.48-6.7-7.22-12.48-7.22-9.89 0-17.03 6.86-17.93 16.61-.9 9.68 4.97 16.54 14.86 16.54 5.78 0 11.01-2.74 13.8-7.15l8.13 4.98c-4.93 7.22-13.53 11.91-22.84 11.91-15.28.01-25.19-11.54-23.83-26.27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.71 49.66-.88 9.53h-31.27l4.68-50.55h30.91l-.88 9.53h-20.94l-1 10.76h19.14l-.87 9.38h-19.14l-1.05 11.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m266.68 47.09-8.33 12.09h-11.27l14.52-21.09zm-2.73-38.26 25.37 50.36h-11.34l-24.95-50.36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.07 43.13-12.03-25.1 9.43-.07 2.95 5.85 9.75-14.98h12.05z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m30.05 0c-.89 0-1.63.68-1.71 1.56l-.29 3.2-.03.35-.78 8.6v.01l-.32 3.46c2.25-1.06 4.76-1.65 7.41-1.65.79 0 1.56.06 2.32.16 2.58.3 4.94 1.14 6.98 2.43.88.56 1.7 1.19 2.45 1.9 1.82 1.59 3.42 3.42 4.74 5.46 1.17 1.8 2.11 3.74 2.81 5.81.87 2.6 1.36 5.38 1.36 8.27 0 12.27-8.54 22.54-19.99 25.22 15.65-2.38 27.64-15.89 27.64-32.21-.01-17.98-14.6-32.57-32.59-32.57z",
    fill: "url(#b)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.36 45.69c-.64.59-1.28 1.17-1.94 1.74.68-.54 1.33-1.12 1.94-1.74z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.55 34.91c-.23-1.24-.54-2.44-.93-3.61-.7-2.07-1.64-4.01-2.81-5.81-1.32-2.03-2.92-3.87-4.74-5.46 2.63 2.48 4.4 5.83 4.93 9.64.15 1.07.2 2.18.14 3.31-.01.15-.01.3-.02.46-.16 2.13-.7 4.18-1.54 6.08-1.01 2.29-2.46 4.38-4.23 6.16-.61.62-1.26 1.2-1.94 1.74-10.74 9.2-24.7 14.75-39.95 14.75-1.14 0-2.28-.03-3.41-.1.31 1.75 1.83 3.08 3.66 3.08h26.33c1.68 0 3.33-.13 4.94-.37 11.46-2.68 19.99-12.95 19.99-25.22.01-1.59-.14-3.14-.42-4.65z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.85 51.93h-17.2c-.18 0-.36-.04-.51-.1-.06-.02-.12-.06-.18-.09-4.38-.32-8.44-1.77-11.89-4.07l-1.07 13.77c0 .22.02.43.06.64 1.13.06 2.27.1 3.41.1 15.25 0 29.2-5.56 39.95-14.75-3.55 2.8-7.97 4.5-12.57 4.5z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.67 0h-13.48c-2.06 0-3.72 1.67-3.72 3.72l-1.05 13.6-.63 8.15-.52 6.75-.59 7.6-.61 7.86c3.45 2.3 7.51 3.76 11.89 4.07-.15-.08-.3-.19-.41-.32-.23-.28-.35-.64-.31-1.04l1.59-17.47 1.39-15.23.51-5.55.37-4.14.15-1.6.1-1.06.01-.07h.04c0-2.91 2.36-5.27 5.27-5.27z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.68 26.39c-.28-.09-.58-.14-.87-.16-1.34-.09-2.61.39-3.76.93l-1.17 12.82c0 .04 0 .09.01.13.33.13.68.24 1.03.32.54.12 1.1.2 1.68.2.6 0 1.17-.08 1.73-.21 1.02-.24 1.96-.7 2.77-1.31 1.79-1.36 2.95-3.51 2.95-5.93 0-3.02-1.67-5.94-4.37-6.79z",
    fill: "url(#f)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcex);
export default __webpack_public_path__ + "static/media/btcex.668f6a116dbdbf45d48380a3359f5278.svg";
export { ForwardRef as ReactComponent };